import Link from 'next/link';
import classNames from 'classnames';

import { DateTime } from '@components/dateTime/DateTime';
import { Image } from '@components/Image/Image';

import { catchOrphanedWords } from '@common/utils/string';
import { ZINE_URL } from '@data/constants';
import { DatoZinePostPreview } from '@interfaces';

import styles from './zine-post-preview.module.scss';

type ZinePostPreviewProps = {
	post: DatoZinePostPreview;
	sizes: string;
	isInFrontpage?: boolean;
};

export const ZinePostPreview = ({
	post,
	sizes,
	isInFrontpage,
}: ZinePostPreviewProps) => {
	const {
		title,
		firstPublishedAt,
		updatedAt,
		slug,
		thumbnailImage,
		featuredImage,
		subheading,
	} = post;
	// Use `thumbnailImage` as an override for the `featuredImage`
	const image = thumbnailImage || featuredImage;

	return (
		<article
			className={classNames(styles.preview, {
				[styles['preview--is-in-frontpage']]: isInFrontpage,
			})}
		>
			{image ? (
				<Image
					className={styles.image}
					hasCaption={false}
					image={image}
					sizes={sizes}
				/>
			) : (
				<div className={classNames(styles.image, styles['image--empty'])} />
			)}
			<header className={styles.header}>
				<h2 className={styles.heading}>
					<Link
						aria-label={title}
						className="breakout"
						dangerouslySetInnerHTML={{
							__html: catchOrphanedWords(title, 3),
						}}
						href={`${ZINE_URL}/${slug}`}
					/>
				</h2>
				{subheading ? (
					<p
						className={styles.subheading}
						dangerouslySetInnerHTML={{
							__html: catchOrphanedWords(subheading, 3),
						}}
					/>
				) : null}
				<DateTime
					className={classNames(styles.date, 'font-t6-medium')}
					date={new Date(firstPublishedAt || updatedAt)}
				/>
			</header>
		</article>
	);
};
